import { render, staticRenderFns } from "./AddICard.vue?vue&type=template&id=776b05c3&"
import script from "./AddICard.vue?vue&type=script&lang=js&"
export * from "./AddICard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports